<header id="header" class="header-SSBA">
  <!-- Health pillar -->
  <div class="pillar-ssba-gradient"></div>
  <div class="pillar-base"></div>

  <!-- Banner displayed based on viewport size -->
  @if (screenSize() === "desktop") {
    <!-- Desktop banner  -->
    <div id="desktop-header" class="header-row">
      <div class="img-rotated">
        <div>
          <img ngSrc="./assets/SSBA.jpg" alt="SSBA logo" width="75" height="75" priority>
        </div>
        <div>
          <img ngSrc="./assets/SSBA.jpg" alt="SSBA logo" width="75" height="75" priority>
        </div>
      </div>
      <h1 class="title desktop">Security Sensitive Biological Agents Regulatory Scheme</h1>
      <h1 class="training-facility-title">ONLINE TRAINING FACILITY - ADMIN</h1>
    </div>
  } @else {

    <!-- Mobile banner -->
    <div id="mobile-header" class="centred">
      <h1 class="title">SSBA Online Training Facility - Admin</h1>
    </div>
  }

  <!-- Navigation -->
  <app-nav/>
</header>
